import { render } from "./RoleList.vue?vue&type=template&id=41ca5cea&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"

import "./RoleList.vue?vue&type=style&index=0&id=41ca5cea&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ca5cea"]])

export default __exports__